export default __webpack_public_path__ + "static/4-f1f46a6c491111be93036f6ebdfce227.jpeg";